/* eslint-disable camelcase */

const themeV2 = {
  black: '#000000',
  white: '#ffffff',
  primary: '#E2E2E2',
  btnGreyBackground: '#F8F8F8',
  error: '#F35959',
  red: '#FF0000',
  yellow: '#FFD700',
  baseGrey: '#C8C5C5',
  inputColor: '#E2E2E2',
  subtitle: '#808080',
  detail: '#F5F5F5',
  link: '#2D5BFF',
  subtitleGrey: '#9CA2A7',
  notValidated: '#FAA000',
  backgroundImage: '#E9EEF1',
  activation: '#3EAC7B',
  llmInputBgColor: '#FEF8F8',
  contents: '#2D5BFF',
  errorBg: '#EE8E87'
};

const designSystem = {
  ink: '#1f2733',
  inkSoft: '#4a5566',
  muted: '#7a8493',
  faint: '#9aa3b0',
  switchOff: '#cfd5dd',
  knobShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
  line: '#e6e8ec',
  lineSoft: '#eef0f3',
  bgSoft: '#f6f7f9',
  bgBar: '#eef1f4',
  green: '#1f9d5a',
  greenDark: '#178049',
  teal: '#0f9e8f',
  tealGlow: 'rgba(15, 158, 143, 0.15)',
  blue: '#2f6fbf',
  blueBg: '#e8f0fb',
  amber: '#9a6b00',
  amberBg: '#fcefd2',
  amberBorder: '#f0dca8',
  amberDark: '#7c5500',
  orange: '#e07b00',
  orangeBg: '#fde7cf',
  red: '#d64545',
  redBg: '#fbe9e9',
  violet: '#6d59c9',
  violetBg: '#ece8fb',
  greenBg: '#e4f3ea',
  leaderDot: '#cdd2d9',
  radius: '8px'
};

export default {
  dark: {
    primary_header: '#1e1e2f',
    primary: '#1e1e2f',
    secondary: '#383B50',
    tertiary: '#5A5A76',
    funnel: '#009fe3',
    funnel_dark: '#0086bf',
    contents: '#2D5BFF',
    activation: '#3EAC7B',
    campaign: '#3EAC7B',
    pml: '#2D5BFF',
    black: '#000000',
    dark: '#000000',
    light: '#ffffff',
    lightSmooth: '#b3b3b3',
    red: '#FF0000',
    error: '#FF0000',
    success: '#28A745',
    danger: '#EB5757',
    delete: '#F35959',
    disabled: 'rgba(0, 0, 0, 0.26)',
    insight: '#ef7d25',
    audience: '#ef7d25',
    orange: '#e07b00',
    shadow: 'transparent',
    baseline_funnel: '#009fe3',
    keep_light: '#ffffff',
    keep_dark: '#000000',
    icon: '#EEEEEE',
    backoffice: '#F2C94C',
    global: '#F2C94C',
    badgeActif: '#CFF5B7',
    badgeDomains: '#F5EFB7',
    badgeFunnel: '#B7E6F5',
    error_gestion_campagne: '#F5C2B7',
    btnBack: '#ffffff',
    btnBackLabel: '#000000',
    llm: '#EF7D25',
    greyLight: '#828282',
    grey_light_button: '#F5F5F5',
    funnel_light_grey: '#BDBDBD',
    themeV2,
    designSystem
  },
  light: {
    delete: '#F35959',
    primary_header: '#1e1e2f',
    primary: '#eef4f9',
    secondary: '#ffffff',
    tertiary: '#f2f2f2',
    funnel: '#009fe3',
    contents: '#2D5BFF',
    funnel_dark: '#0086bf',
    activation: '#3EAC7B',
    campaign: '#3EAC7B',
    pml: '#2D5BFF',
    dark: '#ffffff',
    black: '#000000',
    light: '#4C4E58',
    disabled: 'rgba(0, 0, 0, 0.26)',
    lightSmooth: '#ADAFB8',
    red: '#FF0000',
    error: '#FF0000',
    error_gestion_campagne: '#F5C2B7',
    success: '#28A745',
    danger: '#EB5757',
    insight: '#ef7d25',
    audience: '#ef7d25',
    orange: '#e07b00',
    warning: '#FF9900',
    llm: '#EF7D25',
    shadow: 'lightgrey',
    baseline_funnel: '#ffffff',
    keep_light: '#ffffff',
    keep_dark: '#4C4E58',
    icon: '#4C4E58',
    backoffice: '#F2C94C',
    global: '#F2C94C',
    badgeActif: '#CFF5B7',
    badgeDomains: '#F5EFB7',
    badgeFunnel: '#B7E6F5',
    btnBack: '#000000',
    btnBackLabel: '#ffffff',
    greyLight: '#C8C5C5',
    grey_light_button: '#F5F5F5',
    funnel_light_grey: '#828282',
    themeV2,
    designSystem
  }
};
